import { supplierService } from '@/helpers/services/supplier.service';
import i18n from '@/i18n';
import { sharedHelper, filtersHelper } from '@/utils';

export const SUPPLIER_MODULE = 'supplier';
export const GET_ALL_SUPPLIERS = 'getAllSuppliers';
export const GET_SUPPLIER = 'getSupplier';
export const CREATE_SUPPLIER = 'createSupplier';
export const UPDATE_SUPPLIER = 'updateSupplier';
export const UPDATE_SUPPLIER_STATUS = 'updateSupplierStatus';

const REQUESTING = 'requesting';
const SUCCESS = 'commonSuccess';
const ALL_SUPPLIER_SUCCESS = 'allSupplierSuccess';
const GET_SUPPLIER_SUCCESS = 'getSupplierSuccess';
const FAILURE = 'failure';

export const state = {
	list: {
		data: [],
		pagination: {
			pageNumber: 0,
			pageSize: 0,
			lastPage: 0,
			tableRowsCounts: 0,
			total: 0,
		},
	},
	details: {},
	status: {
		list: true,
		detail: true,
		save: true,
	},
};

export const actions = {
	[GET_ALL_SUPPLIERS]({ commit }, { filter }) {
		commit(REQUESTING, 'list');
		return supplierService.getAllSuppliers(filter).then(
			(result) => {
				commit(ALL_SUPPLIER_SUCCESS, { data: result });
				commit(SUCCESS);
				return result;
			},
			(error) => {
				sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code);
				commit(FAILURE);
			}
		);
	},
	[GET_SUPPLIER]({ commit }, { id }) {
		commit(REQUESTING, 'detail');
		return supplierService.getSupplier(id).then(
			(result) => {
				commit(GET_SUPPLIER_SUCCESS, result);
				return result;
			},
			(error) => {
				sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code);
				commit(FAILURE);
			}
		);
	},
	[CREATE_SUPPLIER]({ commit, dispatch }, { data, filter }) {
		commit(REQUESTING, 'save');
		var message = i18n.t('label.createX', [i18n.t('module.supplier')]);
		return supplierService.createSupplier(data).then(
			(result) => {
				sharedHelper.alertSuccessMessage(message);
				commit(SUCCESS);
				if (filter) dispatch(GET_ALL_SUPPLIERS, { filter });
				return result;
			},
			(error) => {
				sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code);
				commit(FAILURE);
			}
		);
	},
	[UPDATE_SUPPLIER]({ commit, dispatch }, { data, filter }) {
		commit(REQUESTING, 'save');
		var message = i18n.t('label.updateX', [i18n.t('module.supplier')]);
		return supplierService.updateSupplier(data).then(
			(result) => {
				sharedHelper.alertSuccessMessage(message);
				commit(SUCCESS);
				if (filter) dispatch(GET_ALL_SUPPLIERS, { filter });
				return result;
			},
			(error) => {
				sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code);
				commit(FAILURE);
			}
		);
	},
	[UPDATE_SUPPLIER_STATUS]({ commit, dispatch }, { data, filter }) {
		commit(REQUESTING, 'save');
		var message = i18n.t(`${data.isActive == 0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [i18n.t('module.supplier')]);
		return supplierService.updateSupplierStatus(data).then(
			(result) => {
				sharedHelper.alertSuccessMessage(message);
				commit(SUCCESS);
				dispatch(GET_ALL_SUPPLIERS, { filter });
				return result;
			},
			(error) => {
				sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code);
				commit(FAILURE);
			}
		);
	},
};

export const mutations = {
	[REQUESTING](state, type) {
		state.status[type] = false;
	},
	[SUCCESS](state) {
		state.status = { list: true, detail: true, save: true };
	},
	[FAILURE](state) {
		state.status = { list: true, detail: true, save: true };
	},
	[ALL_SUPPLIER_SUCCESS](state, { data }) {
		let items = data.data || [];
		state.list.data = items;
		state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination || {});
		if (data.success) {
			state.list.data = items.map((item) => ({
				uuid: item.uuid,
				name: item.name,
				code: item.code,
				email: item.email,
				phone: item.phone,
				isActive: item.is_active,
				isActiveText: filtersHelper.getActivationStatus(item.is_active),
				createdBy: item.created_by,
				createdAt: filtersHelper.getDateFormat(item.created_at),
				updatedBy: item.updated_by,
				updatedAt: filtersHelper.getDateFormat(item.updated_at),
			}));
		}
	},
	[GET_SUPPLIER_SUCCESS](state, data) {
		let info = data.data;
		state.details = {
			id: info.uuid,
			name: info.name,
			code: info.code,
			email: info.email,
			phone: info.phone,
			isActive: info.is_active,
			createdBy: info.created_by,
			createdAt: filtersHelper.getDateFormat(info.created_at),
			updatedBy: info.updated_by,
			updatedAt: filtersHelper.getDateFormat(info.updated_at),
		};
		state.status = { list: true, detail: true, save: true };
	},
};
